import Reflux from 'reflux';
import { Map, List, OrderedMap } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import EventFilterActions from 'flux/actions/EventFilterActions';
import UserEventListActions from 'flux/actions/UserEventListActions';

import {
  ALL_EVENT_FILTERS,
  UPCOMING_EVENT_FILTERS,
  PAST_EVENT_FILTERS,
  DELETED_EVENT_FILTERS,
} from 'shared/constants/EventFilters';

import {
  ALL_TITLE,
  ALL,
  UPCOMING_TITLE,
  UPCOMING,
  PAST,
  DELETED_TITLE,
  DELETED,
} from 'shared/constants/EventTypes';

const onUserEventListPopulateCompleted =
  UserEventListActions.populate.completed;

/**
 * Event Filter Stores
 *
 * Keeps track of filters applied to event lists
 */
export default Reflux.createStore({
  listenables: [EventFilterActions],

  mixins: [BaseMixin],

  init() {
    this._init();

    this.listenTo(onUserEventListPopulateCompleted, 'onClear');
  },

  _init() {
    this.setStateAndTrigger(
      Map({
        activeType: UPCOMING,
        activeTitle: UPCOMING_TITLE,
        query: UPCOMING_EVENT_FILTERS,
      }),
    );
  },

  /**
   * Set filters back to the defaults
   */
  onClear() {
    this._init();
  },

  /**
   * Filter for all events
   */
  onApplyAllFilter() {
    let next = this.getState()
      .set('activeType', ALL)
      .set('activeTitle', ALL_TITLE);

    next = this._clearLabelAndOwnerFilters(next);

    this.setState(next);

    this._updateFilterQuery(ALL_EVENT_FILTERS);
  },

  /**
   * Filter for upcoming events
   */
  onApplyUpcomingFilter() {
    let next = this.getState()
      .set('activeType', UPCOMING)
      .set('activeTitle', UPCOMING_TITLE);

    next = this._clearLabelAndOwnerFilters(next);

    this.setState(next);

    this._updateFilterQuery(UPCOMING_EVENT_FILTERS);
  },

  /**
   * Filter for past events
   */
  onApplyPastFilter() {
    let next = this.getState()
      .set('activeType', PAST)
      .set('activeTitle', UPCOMING_TITLE);

    next = this._clearLabelAndOwnerFilters(next);

    this.setState(next);

    this._updateFilterQuery(PAST_EVENT_FILTERS);
  },

  /**
   * Filter for deleted events
   */
  onApplyDeletedFilter() {
    let next = this.getState()
      .set('activeType', DELETED)
      .set('activeTitle', DELETED_TITLE);

    next = this._clearLabelAndOwnerFilters(next);

    this.setState(next);

    this._updateFilterQuery(DELETED_EVENT_FILTERS);
  },

  onUpdateOwnerFilters(ownerId) {
    let next = this.getState();
    const ownerIndex = next.get('owners')
      ? next.get('owners').indexOf(ownerId)
      : -1;

    if (ownerIndex !== -1) {
      /**
       * If owner already exists then remove it from filters
       */
      next = next.update('owners', (owners) => owners.splice(ownerIndex, 1));
    } else {
      next = next.update('owners', (owners) => {
        let ownerList = owners || List();
        return ownerList.push(ownerId);
      });
    }

    this.setState(next);

    const query = { owners: next.get('owners') };

    this._updateFilterQuery(query);
  },

  onClearOwnerFilters() {
    const next = this._clearOwnerFilters(this.getState());

    this.setStateAndTrigger(next);
  },

  onUpdateLabelFilters(labelId, label) {
    let next = this.getState();

    if (next.getIn(['labels', labelId])) {
      /**
       * If label aready exists then remove it from filters
       */
      next = next.deleteIn(['labels', labelId]);
    } else {
      /**
       * Store labels as OrderedMap for reference
       */
      next = next.update('labels', (labels) => {
        let labelList = labels || OrderedMap();
        return labelList.set(labelId, label);
      });
    }

    this.setState(next);

    /**
     * Add label ids to be used in filter query
     */
    const labelIds = [];
    next.get('labels').forEach((label, id) => labelIds.push(id));

    const query = { labels: labelIds };
    this._updateFilterQuery(query);
  },

  onClearLabelFilters() {
    const next = this._clearLaberFilters(this.getState());

    this.setStateAndTrigger(next);
  },

  _clearLabelAndOwnerFilters(state) {
    let nextState = this._clearLaberFilters(state);
    nextState = this._clearOwnerFilters(nextState);

    return nextState;
  },

  _clearLaberFilters(state) {
    const nextState = state.delete('labels').deleteIn(['query', 'labels']);

    return nextState;
  },

  _clearOwnerFilters(state) {
    const nextState = state.delete('owners').deleteIn(['query', 'owners']);

    return nextState;
  },

  _updateFilterQuery(newQuery) {
    const next = this.getState().update('query', (query) => {
      return query.merge(newQuery);
    });

    this.setStateAndTrigger(next);
  },
});
